// 登录方式 login:账号登录 reg:验证码登录  qrcode:二维码登录
// eslint-disable-next-line import/prefer-default-export
export enum ELoginType {
  Login = 'login',
  Reg = 'reg',
  Qrcode = 'qrcode',
}
